<template>
    <div class="project">
        <section class="banner">
            <router-link to="/"><img alt="back" title="Back" class="backArrow" width="40px" height="40px" src="../assets/img/WhiteArrow.svg" ></router-link></section>
        <section class="titleBanner">
            <div class="RightBanner">
                <h1 class="Title">Form Creator</h1>
                <h2 class="subHeader">Personal Project</h2>
                <h2 class="subHeader">In-Progress 2020</h2>
            </div>
        </section>
        <section class="projectContent">
            
                <div class="content">
                        <div class="left chimeImg"> <img alt="FormCreator"  title="FormCreator UI"  class="projectImg" src="../assets/img/FormCreator.svg"></div>
                <div class="right">
                    <p class="description">Form Creator is an app that I was inspired to develop after observing the struggles a local foundry was encountering with the software they were utilizing for production flow.  I began this process by learning how to use SwiftUI to create something that would build the scalability the app required. This project is still very much in development as I am constantly reevaluating how to best meet the user’s needs.  </p>
                </div>
                </div>
            <div class="gallery">
                <h1 class="Title">Concept UI</h1>
                <div class="container">
                    <div class="item ImgOne" v-on:click="expand('StartScreen.svg')">
                        <img alt="Welcome Screen" title="Welcome Screen" src="../assets/img/StartScreen.svg">
                        <p class="tagline">Welcome Screen</p>
                    </div>
                     <div class="item " v-on:click="expand('Frame2.svg')" >
                        <img alt="Return Screen" title="Return Screen" src="../assets/img/Frame2.svg">
                        <p class="tagline">Return Screen</p>
                    </div>
                    <div class="item" v-on:click="expand('Frame3.svg')" >
                        <img alt="Form Selection" title="Form Selection" src="../assets/img/Frame3.svg">
                        <p class="tagline">Form Selection Screen</p>
                    </div>
                    <div class="item" v-on:click="expand('Frame4.svg')" >
                        <img alt="Form Screen" title="Form Screen" src="../assets/img/Frame4.svg">
                        <p class="tagline">Form Screen</p>
                    </div>
                    <div class="item" v-on:click="expand('Frame5.svg')" >
                        <img alt="Menu" title="Filled Form Menu" src="../assets/img/Frame5.svg">
                        <p class="tagline">Filled Form Menu</p>
                    </div>
                </div>
                </div>

        </section>

     <div class="modal" v-on:click="toggle()">
            <div class="mImage">
                <img id="display" alt="Mood Board" title="Mood Board">
            </div>
        </div>

    </div>
</template>
<style scoped>
    .banner {
       background: linear-gradient(159.89deg, #25A4FF 5.41%, #087CD0 87.74%);
    }

    html {
        width: 100%;
        height: auto;
        background: radial-gradient(78.3% 77.16% at 92.4% 97.56%, #F8F9FF 0%, #DBDDE3 100%) no-repeat center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        background-position: top;
        position: relative;
    }
     .content img {
        object-position: center;
        min-width: 45vw;
        width: 100%;
        overflow-x: hidden;
    }
    .gallery{
        margin-top: 10vh;
        justify-content: center;
    }
    .gallery .Title{
        padding: 25px;
    }
    .container{
        max-width: 100vw;
        height: auto;
        background-color: #1B1B1D;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 0 auto;
        padding-bottom: 3vh;
    }

    .item {
        vertical-align: middle;
        margin: 3vw;
        min-width: 400px;
        width: 100%;
        max-width: 30vw;
        height: auto;
        flex: 20%;
        flex-grow: 1;
    }
    .item img {
           vertical-align: middle;
           margin: auto 0;
           width: 100%;
           
    }
    .modal{
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        position: fixed;
        z-index: 9;
        background-color: rgba(0, 0, 0, 0.62);
        justify-content: center;
        visibility: hidden;
        opacity: 0;
        transition: 0.4s ease-in-out;
        
    }
    
   .modal.show{
        visibility: visible;
        opacity: 1;
    
    }
    .mImage{
        z-index: 10;
        justify-content: center;
           position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    }
    .mImage{
        object-position: center;
    }
    #display {
        width: 65vw;
        max-width: 1000px;
    }
</style>
<script>
    "use strict"

    export default {
        name: 'FormCreator',
        props: {},
        components: {

        },
         methods: {
             expand(img) {
                 const image = require('../assets/img/'+img)
                 $('#display').attr("src",image)
                 console.log(img)
                //document.getElementById('display').src=img
                 this.toggle()
             },
             toggle() {
                $('.modal').toggleClass('show')
             },
              CallHome() { 
                window.location = '/'
                }
            

         }

    }

</script>